import { black, primary } from '../../colors';
import idsTokensDefault from '../../utils/tokens/idsTokens';

export const classes = (idsTokens = idsTokensDefault) => ({
  root: {
    '&:hover': {
      color: black,
      '&& .MuiTableSortLabel-icon': {
        color: primary,
        opacity: 1,
      },
    },
    '&.Mui-active': {
      color: black,
      fontWeight: idsTokens.typography.font.weight.semibold,
      '& .MuiTableSortLabel-icon': {
        color: black,
      },
    },
    '&:not(.Mui-active)': {
      '@global svg': {
        transform: 'rotate(180deg)',
      },
    },
  },
  icon: {
    width: 16,
    height: 16,
  },
});
